/* *
 * By The Christian Post.
 * The earth shall be full of the knowledge of the Lord as the waters cover the sea! Isaiah 11:9
 * */

import Navigator from './navigators'

export default function App() {
  return (
    <Navigator />
  );
}

/* *
 * STANDARD FOOTER:
 * The earth shall be full of the knowledge of the Lord as the waters cover the sea! Isaiah 11:9
 * */
